module.exports = __webpack_public_path__ + "static/media/photo-1-m.6e5bb2b6.jpeg";